import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, WbsMeta } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  meta: WbsMeta;
  retrieveWbsMeta(req: Boundaries["retrieveWbsMeta"]["request"]): void;
}

function useRetrieveWbsMeta(projects: Identifiable<Project>[]): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveWbsMetaRequestPending(projects),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveWbsMetaRequestSuccess(projects),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveWbsMetaRequestFailure(projects),
    ),
    meta: useSelector(() => selector.getWbsMeta(projects)),
    retrieveWbsMeta: core.retrieveWbsMeta,
  };
}

export { useRetrieveWbsMeta };
